export const WORKFLOW_FAMILY_LABELS = {
  leave: "الإجازات",
  permit: "الأذونات",
  overtime: "الإضافي",
  wfh: "العمل عن بُعد",
  weekly_rest: "الراحة الأسبوعية",
  timesheet: "الخطة الأسبوعية",
  advance: "السلف",
  complaint: "الشكاوى",
  appeal: "التظلمات",
  payroll: "الرواتب",
  resignation: "الاستقالة",
  inventory_night: "الجرد",
  job_requisition: "طلبات التوظيف",
  job_offer: "عروض العمل",
  other: "أخرى",
};

const FAMILY_KEYS = [
  "inventory_night",
  "weekly_rest",
  "job_requisition",
  "job_offer",
  "timesheet",
  "resignation",
  "complaint",
  "appeal",
  "overtime",
  "advance",
  "payroll",
  "permit",
  "leave",
  "wfh",
];

export const WORKFLOW_TITLE_LABELS = {
  leave: "سايكل الإجازة — التشغيل",
  leave_bm: "سايكل الإجازة — مدير الفرع",
  leave_rm: "سايكل الإجازة — المدير الإقليمي",
  leave_admin: "سايكل الإجازة — الإدارات الإدارية",
  leave_cashier: "سايكل الإجازة — الكاشير",
  leave_acc: "سايكل الإجازة — الحسابات",
  leave_acc_head: "سايكل الإجازة — رئيس الحسابات",
  leave_direct_gm: "سايكل الإجازة — للمدير العام",
  permit: "سايكل الإذن — التشغيل",
  permit_bm: "سايكل الإذن — مدير الفرع",
  permit_rm: "سايكل الإذن — المدير الإقليمي",
  permit_admin: "سايكل الإذن — الإدارات الإدارية",
  permit_cashier: "سايكل الإذن — الكاشير",
  permit_acc: "سايكل الإذن — الحسابات",
  permit_acc_head: "سايكل الإذن — رئيس الحسابات",
  permit_direct_gm: "سايكل الإذن — للمدير العام",
  overtime: "سايكل الإضافي — التشغيل",
  overtime_bm: "سايكل الإضافي — مدير الفرع",
  overtime_rm: "سايكل الإضافي — المدير الإقليمي",
  overtime_admin: "سايكل الإضافي — الإدارات الإدارية",
  overtime_cashier: "سايكل الإضافي — الكاشير",
  overtime_acc: "سايكل الإضافي — الحسابات",
  overtime_acc_head: "سايكل الإضافي — رئيس الحسابات",
  overtime_inventory: "سايكل منح الإضافي",
  overtime_direct_gm: "سايكل الإضافي — للمدير العام",
  wfh: "سايكل العمل عن بُعد — المدير المباشر",
  wfh_admin: "سايكل العمل عن بُعد — الإدارات الإدارية",
  wfh_cashier: "سايكل العمل عن بُعد — الكاشير",
  wfh_acc: "سايكل العمل عن بُعد — الحسابات",
  wfh_acc_head: "سايكل العمل عن بُعد — رئيس الحسابات",
  weekly_rest: "سايكل الراحة الأسبوعية — التشغيل",
  weekly_rest_bm: "سايكل الراحة الأسبوعية — مدير الفرع",
  weekly_rest_rm: "سايكل الراحة الأسبوعية — المدير الإقليمي",
  weekly_rest_admin: "سايكل الراحة الأسبوعية — الإدارات الإدارية",
  weekly_rest_cashier: "سايكل الراحة الأسبوعية — الكاشير",
  weekly_rest_acc: "سايكل الراحة الأسبوعية — الحسابات",
  weekly_rest_acc_head: "سايكل الراحة الأسبوعية — رئيس الحسابات",
  timesheet_marketing: "سايكل الخطة الأسبوعية — التسويق",
  timesheet_moderator: "سايكل الخطة الأسبوعية — الموديريتور",
  timesheet_warehouse: "سايكل الخطة الأسبوعية — المخزن",
  timesheet_admin: "سايكل الخطة الأسبوعية — احتياطي إداري",
  advance: "سايكل السلفة العادية",
  advance_admin: "سايكل السلفة العادية — إداري",
  advance_via_manager: "سايكل السلفة الاستثنائية",
  advance_direct_gm: "سايكل السلفة — مباشر للموارد البشرية",
  complaint: "سايكل الشكوى — التشغيل",
  complaint_bm: "سايكل الشكوى — مدير الفرع",
  complaint_rm: "سايكل الشكوى — المدير الإقليمي",
  complaint_admin: "سايكل الشكوى — الإدارات الإدارية",
  complaint_cashier: "سايكل الشكوى — الكاشير",
  complaint_acc: "سايكل الشكوى — الحسابات",
  complaint_acc_head: "سايكل الشكوى — رئيس الحسابات",
  appeal: "سايكل التظلم — التشغيل",
  appeal_bm: "سايكل التظلم — مدير الفرع",
  appeal_rm: "سايكل التظلم — المدير الإقليمي",
  appeal_admin: "سايكل التظلم — الإدارات الإدارية",
  appeal_marketing: "سايكل التظلم — التسويق",
  appeal_cashier: "سايكل التظلم — الكاشير",
  appeal_acc: "سايكل التظلم — الحسابات",
  appeal_acc_head: "سايكل التظلم — رئيس الحسابات",
  appeal_dm: "سايكل التظلم — مدير إدارة",
  payroll: "سايكل الرواتب",
  resignation: "سايكل الاستقالة",
  inventory_night: "سايكل الجرد",
  job_requisition: "سايكل طلب وظيفة — مدير إدارة",
  job_requisition_hr: "سايكل طلب وظيفة — موارد بشرية",
  job_offer: "سايكل عرض العمل",
};

export const WORKFLOW_AUDIENCE_LABELS = {
  leave: "موظفو التشغيل / الفروع",
  leave_bm: "مدير الفرع (طلب شخصي)",
  leave_rm: "المدير الإقليمي (طلب شخصي)",
  leave_admin: "الإدارات الإدارية",
  leave_cashier: "كاشير الفرع",
  leave_acc: "موظفو الحسابات",
  leave_acc_head: "رئيس الحسابات",
  leave_direct_gm: "الموارد البشرية / مدير إدارة (للمدير العام)",
  permit: "موظفو التشغيل / الفروع",
  permit_bm: "مدير الفرع (طلب شخصي)",
  permit_rm: "المدير الإقليمي (طلب شخصي)",
  permit_admin: "الإدارات الإدارية",
  permit_cashier: "كاشير الفرع",
  permit_acc: "موظفو الحسابات",
  permit_acc_head: "رئيس الحسابات",
  permit_direct_gm: "الموارد البشرية / مدير إدارة (للمدير العام)",
  overtime: "موظفو التشغيل / الفروع",
  overtime_bm: "مدير الفرع (طلب شخصي)",
  overtime_rm: "المدير الإقليمي (طلب شخصي)",
  overtime_admin: "الإدارات الإدارية",
  overtime_cashier: "كاشير الفرع",
  overtime_acc: "موظفو الحسابات",
  overtime_acc_head: "رئيس الحسابات",
  overtime_inventory: "منح إضافي من الموارد البشرية",
  overtime_direct_gm: "الموارد البشرية / مدير إدارة (للمدير العام)",
  wfh: "الموظفون (مدير مباشر)",
  wfh_admin: "الإدارات الإدارية",
  wfh_cashier: "كاشير الفرع",
  wfh_acc: "موظفو الحسابات",
  wfh_acc_head: "رئيس الحسابات",
  weekly_rest: "موظفو التشغيل / الفروع",
  weekly_rest_bm: "مدير الفرع (طلب شخصي)",
  weekly_rest_rm: "المدير الإقليمي (طلب شخصي)",
  weekly_rest_admin: "الإدارات الإدارية",
  weekly_rest_cashier: "كاشير الفرع",
  weekly_rest_acc: "موظفو الحسابات",
  weekly_rest_acc_head: "رئيس الحسابات",
  timesheet_marketing: "فريق التسويق",
  timesheet_moderator: "فريق الموديريتور",
  timesheet_warehouse: "أمين المخزن",
  timesheet_admin: "الخطة الأسبوعية (احتياطي إداري)",
  advance: "السلفة العادية",
  advance_admin: "السلفة العادية — إداري",
  advance_via_manager: "السلفة الاستثنائية",
  advance_direct_gm: "سلفة مباشرة للموارد البشرية (قديم)",
  complaint: "موظفو التشغيل / الفروع",
  complaint_bm: "مدير الفرع (طلب شخصي)",
  complaint_rm: "المدير الإقليمي (طلب شخصي)",
  complaint_admin: "الإدارات الإدارية",
  complaint_cashier: "كاشير الفرع",
  complaint_acc: "موظفو الحسابات",
  complaint_acc_head: "رئيس الحسابات",
  appeal: "موظفو التشغيل / الفروع",
  appeal_bm: "مدير الفرع (طلب شخصي)",
  appeal_rm: "المدير الإقليمي (طلب شخصي)",
  appeal_admin: "الإدارات الإدارية",
  appeal_marketing: "فريق التسويق",
  appeal_cashier: "كاشير الفرع",
  appeal_acc: "موظفو الحسابات",
  appeal_acc_head: "رئيس الحسابات",
  appeal_dm: "مدير إدارة",
  payroll: "دورة المرتبات",
  resignation: "كل الموظفين",
  inventory_night: "جرد الفرع",
  job_requisition: "طلب وظيفة — مدير إدارة",
  job_requisition_hr: "طلب وظيفة من الموارد البشرية",
  job_offer: "عرض عمل",
};

export const WORKFLOW_RUNTIME_NOTES = {
  timesheet_moderator:
    "في التشغيل الفعلي طلب الموديريتور بيمشي على المدير المباشر شخص بشخص لحد الموارد البشرية.",
  timesheet_marketing:
    "فريق التسويق بيتوجّه حسب سلسلة التسويق الإدارية، مش حسب الأدوار الثابتة بس.",
  advance: "السلفة العادية بتروح للموارد البشرية مباشرة.",
  advance_admin: "السلفة العادية للإداريين بتروح للموارد البشرية مباشرة.",
  advance_via_manager:
    "السلفة الاستثنائية: المدير المباشر ثم الموارد البشرية فقط.",
  appeal:
    "المسار الافتراضي للتشغيل: المدير المباشر → المدير الإقليمي → مدير الإدارة → الموارد البشرية. تقدر تعدّل الخطوات من هنا.",
  appeal_bm: "تظلم مدير الفرع بيبدأ من المدير الإقليمي.",
  appeal_rm: "تظلم المدير الإقليمي بيبدأ من مدير الإدارة.",
  appeal_admin:
    "الإدارات الإدارية: المدير المباشر → مدير الإدارة → الموارد البشرية.",
  appeal_marketing:
    "التسويق: المدير المباشر → مدير المدير (لو موجود تحت مدير الإدارة) → مدير إدارة التسويق → الموارد البشرية.",
  appeal_cashier: "الكاشير ومدير الكاشيرية: المدير المباشر → الموارد البشرية.",
  appeal_acc: "موظفو الحسابات: المدير المباشر → الموارد البشرية.",
  appeal_acc_head: "رئيس قسم الحسابات: مدير الإدارة → الموارد البشرية.",
  appeal_dm: "مدير الإدارة بيروح للموارد البشرية مباشرة.",
};

const ARABIC_CHAR = /[\u0600-\u06FF]/;

export function getWorkflowFamilyKey(requestType = "") {
  const type = String(requestType || "");
  return (
    FAMILY_KEYS.find((key) => type === key || type.startsWith(`${key}_`)) ||
    "other"
  );
}

export function getWorkflowFamilyLabel(requestType) {
  return WORKFLOW_FAMILY_LABELS[getWorkflowFamilyKey(requestType)] || "أخرى";
}

export function getWorkflowAudienceLabel(requestType, workflow) {
  if (workflow?.isCustom || String(requestType || "").includes("_custom_")) {
    const names = (workflow?.assignees || [])
      .map((row) => row.employee?.fullName || row.fullName)
      .filter(Boolean);
    if (names.length) {
      return names.length > 3
        ? `${names.slice(0, 3).join("، ")} و${names.length - 3} غيرهم`
        : names.join("، ");
    }
    return "موظفون محددون";
  }
  return WORKFLOW_AUDIENCE_LABELS[requestType] || "حسابات مرتبطة بهذا المسار";
}

export function getWorkflowDisplayName(workflow) {
  const stored = String(workflow?.name || "").trim();
  if (ARABIC_CHAR.test(stored)) return stored;
  const mapped = WORKFLOW_TITLE_LABELS[workflow?.requestType];
  if (mapped) return mapped;
  const family = getWorkflowFamilyLabel(workflow?.requestType);
  const audience = getWorkflowAudienceLabel(workflow?.requestType);
  return `سايكل ${family} — ${audience}`;
}

export function getWorkflowRuntimeNote(requestType) {
  return WORKFLOW_RUNTIME_NOTES[requestType] || "";
}

export function groupWorkflowsByFamily(workflows = []) {
  const groups = new Map();
  workflows.forEach((workflow) => {
    const key = getWorkflowFamilyKey(workflow.requestType);
    if (!groups.has(key)) {
      groups.set(key, {
        key,
        label: WORKFLOW_FAMILY_LABELS[key] || "أخرى",
        items: [],
      });
    }
    groups.get(key).items.push(workflow);
  });
  return [...groups.values()];
}
